import Swiper from 'swiper/bundle';

const HeroSlider = () => {
  const sliders = document.querySelectorAll('.hero-slider__swiper');

  if (!sliders.length) return;

  sliders.forEach((slider) => {
    if (!(slider instanceof Element)) return;

    const swiperWrapper = slider.querySelector('.hero-slider__swiper-wrapper');

    if (!swiperWrapper) return;

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      pagination: {
        el: slider.querySelector('.media-textarea__pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.media-textarea__nav--next'),
        prevEl: slider.querySelector('.media-textarea__nav--prev'),
      },
    });
  });
};

export default HeroSlider;
